export interface AzmoonMaharatDetail_Files_Interface {
    id:number,
    detail_id:number,
    title:string,
    templateSrc:string,

  }
  
  export function Empty_AzmoonMaharatDetail_Files_Interface():AzmoonMaharatDetail_Files_Interface{
    return{
      id:0,
      detail_id:0,
      title:'',
      templateSrc:'',
    }
  }
